import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useNavButtonStyle from '../styles/NavButtonStyles.jsx';

const NavButton = ({ text = '' }) => {
  const [hovered, setHovered] = useState(false);
  const props = {
    hovered,
  };
  const classes = useNavButtonStyle(props);
  const navigate = useNavigate();

  const handleNav = e => {
    const navText = e.target.innerText;
    const redirectTo = navText !== 'HELLO FROM TINGJUN!' ? navText.toLowerCase() : '';
    navigate(`/${redirectTo}`, { replace: true });
  };

  const hoverNavOn = () => {
    setHovered(true);
  };

  const hoverNavOff = () => {
    setHovered(false);
  };

  return (
    <Typography
      className={!hovered ? classes.root : classes.hovered}
      onClick={handleNav}
      onMouseEnter={hoverNavOn}
      onMouseLeave={hoverNavOff}
    >
      {text}
    </Typography>
  );
};

NavButton.propTypes = {
  text: PropTypes.string,
};

export default NavButton;
